import { TextKey } from '@mews-commander/enums';
import { LocalizedParagraph } from '@mews-commander/ui';
import { LocalizedSectionTitleLarge } from '../../components/Typography';
import { RepaymentPlanLayout } from '../../components/Layouts/RepaymentPlanLayout';
import { RepaymentBarChart } from './RepaymentBarChart';

export const RepaymentPlanSection = () => {
    const data = [150, 250, 375, 450, 300, 350, 175, 500, 100, 250];

    return (
        <RepaymentPlanLayout>
            <LocalizedSectionTitleLarge
                textKey={TextKey.FinancialServicesCapitalStressFreeRepaymentPlan}
                align="center"
            />
            <LocalizedParagraph textKey={TextKey.FinancialServicesCapitalRepaymentsWillBeFixed} align="center" />
            <RepaymentBarChart data={data} />
        </RepaymentPlanLayout>
    );
};
